import { type ChoiceStorage, ViewContextProvider as Provider } from '@shkola/api';
import type { ReactNode } from 'react';

const STORAGE_KEY = 'shkola.context';

// private mode or blocked storage: the choice simply is not remembered
const storage: ChoiceStorage = {
  get: () => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  },
  set: (key) => {
    try {
      localStorage.setItem(STORAGE_KEY, key);
    } catch {
      // ignore
    }
  },
};

export function ViewContextProvider({ children }: { children: ReactNode }) {
  return <Provider storage={storage}>{children}</Provider>;
}

export { useCurrentContext, useViewContext } from '@shkola/api';
